import axios from "axios";
import {GET_ME} from "./RestCatalog";

const getCurrentUser = () => {
    return axios.get(GET_ME)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

export { getCurrentUser };